export default __webpack_public_path__ + "static/green-motion-phone-b13ca6fd393003457db7ea060a97a1d9.png";